import { createContext, useContext } from 'react';

const ContentContext = createContext({ initialSurah: null, initialQuiz: null });

export function ContentProvider({ initialSurah = null, initialQuiz = null, children }) {
  return <ContentContext.Provider value={{ initialSurah, initialQuiz }}>{children}</ContentContext.Provider>;
}

export function useInitialContent() {
  return useContext(ContentContext);
}
